import { useCallback, useEffect, useRef } from "react";

export function useTimeout(callback: () => void, delay: number) {
  const timeoutId = useRef<ReturnType<typeof setTimeout>>(undefined);

  const memoizedCallback = useCallback(callback, []);

  const clear = () => {
    clearTimeout(timeoutId.current);
  };

  useEffect(() => {
    if (delay < 0) {
      return;
    }

    timeoutId.current = setTimeout(memoizedCallback, delay);

    return clear;
  }, [memoizedCallback, delay]);

  return clear;
}
